import { httpPost } from "utils/httpRequest"

const getCMSConfig = async () => {
  const resp = await httpPost("admin/systemSetting/getCmsConfig")
  return resp.data
}

export { getCMSConfig }
